















import { defineComponent } from 'vue';

import bus from '@/bus';

import { relatedStoreMapper } from '@/modules/related/dist/store';
import { appStoreMapper } from '@/store/appstore';

import RelatedLogo from './related-logo.vue';

export default defineComponent({
  name: 'RelatedHomeSlotButton',
  components: { RelatedLogo },
  computed: {
    currentDomain(): IRelated | undefined {
      return this.list.find((related) => related.domain === this.domain);
    },
    currentDomainTitle(): string {
      return this.currentDomain?.name || '';
    },
    showButton(): boolean {
      return this.moduleEnabled && !!this.currentDomain;
    },
    ...appStoreMapper.mapState(['domain']),
    ...relatedStoreMapper.mapGetters(['list', 'moduleEnabled', 'settings']),
  },
  methods: {
    onSwitchRelatedClicked() {
      bus.$emit('relatedPopupShow');
    },
  },
});
